import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function RightToAcquirePage() {
  return (
    <div data-testid="right-to-acquire-page">
      <section className="relative bg-[#111111] py-32 lg:py-40">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1920&q=80')] bg-cover bg-center opacity-15" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-[#d64241] font-semibold text-sm tracking-widest uppercase mb-3 font-body">Special Schemes</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight">
            Right to<br /><span className="text-[#d64241]">Acquire</span>
          </h1>
        </div>
      </section>

      <section data-testid="right-to-acquire-content" className="py-20 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            <div>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-8 font-body">
                If you're a housing association tenant in England you could be eligible to buy the home you rent at a discount of between <strong className="text-black">£9,000 and £16,000</strong> on the price of your home. The amount of discount you'll get depends on where you live.
              </p>

              <h2 className="text-2xl md:text-3xl font-semibold text-black tracking-tight mb-4">Am I eligible?</h2>
              <p className="text-base text-gray-600 leading-relaxed mb-4 font-body">
                You can apply to buy your housing association home if you've had a public sector landlord for 3 years or more. These landlords include:
              </p>
              <div className="space-y-2 mb-6">
                {["Housing associations", "Councils", "The armed services", "NHS trusts and foundation trusts"].map((item, i) => (
                  <div key={i} className="flex gap-3">
                    <CheckCircle2 className="w-4 h-4 text-[#d64241] flex-shrink-0 mt-1" />
                    <p className="text-sm text-gray-600 font-body">{item}</p>
                  </div>
                ))}
              </div>

              <p className="text-base text-gray-600 leading-relaxed mb-4 font-body">
                In addition, your property must either have been:
              </p>
              <div className="space-y-2 mb-6">
                {[
                  "Built or bought by a housing association after 31 March 1997 and funded through a social housing grant provided by the Housing Corporation or local council",
                  "Transferred from a local council to a housing association after 31 March 1997",
                ].map((item, i) => (
                  <div key={i} className="flex gap-3">
                    <CheckCircle2 className="w-4 h-4 text-[#d64241] flex-shrink-0 mt-1" />
                    <p className="text-sm text-gray-600 font-body leading-relaxed">{item}</p>
                  </div>
                ))}
              </div>

              <p className="text-base text-gray-600 leading-relaxed mb-4 font-body">
                You can't use Right to Acquire if:
              </p>
              <div className="space-y-2 mb-8">
                {[
                  "You're being made bankrupt",
                  "A court has ordered you to leave your home",
                  "You're a council tenant — you may be able to use Right to Buy instead",
                  "You have 'Preserved Right to Buy'",
                ].map((item, i) => (
                  <div key={i} className="flex gap-3">
                    <XCircle className="w-4 h-4 text-gray-400 flex-shrink-0 mt-1" />
                    <p className="text-sm text-gray-600 font-body">{item}</p>
                  </div>
                ))}
              </div>

              <Link to="/contact">
                <Button data-testid="right-to-acquire-cta-btn" className="bg-[#d64241] hover:bg-[#b53736] text-white rounded-full px-8 py-6 text-base font-semibold shadow-lg shadow-[#d64241]/25 hover:-translate-y-0.5 transition-all duration-200">
                  Get Expert Advice <ArrowRight className="w-4 h-4 ml-1" />
                </Button>
              </Link>
            </div>
            <div>
              <div className="rounded-2xl overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.1)]">
                <img src="https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?w=800&q=80" alt="Right to Acquire" className="w-full h-[400px] lg:h-[550px] object-cover" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
